import { React, Fragment, memo, useState, useEffect } from 'react'
import { HeadingText, BodyText, Button, Row, Col } from '@paypalcorp/pp-react'
import { Message } from '@paypalcorp/worldready-react'
import asASlide from '../../common/as-a-slide'
import { PP_LOGGED_OUT_URL } from '../../../constants/constants'
import { fptiCustomImpression } from '../../../utils'
import DATAPRIVACY_FPTI from '../../../config/data-privacy-fpti'
const loggedOutFPTI = DATAPRIVACY_FPTI.LOGGED_OUT

const Status = memo((props) => {
  const [isReady, setisReady] = useState(false)
  const [impressionDone, setImpressionDone] = useState(false)
  const { modalParams: { dataResponse = {} } = {} } = props

  const handleContinueClick = (event) => {
    event.preventDefault()
    location.href = PP_LOGGED_OUT_URL
  }

  useEffect(() => {
    if (dataResponse.status === 'CLOSED') {
      setisReady(true)
    } else {
      setisReady(false)
    }
    if (!impressionDone) {
      setImpressionDone(true)
      fptiCustomImpression(loggedOutFPTI.STATUS_IMPRESSION)
    }
  }, [])

  const formateDate = (date) => {
    if (date) {
      const dateobj = new Date(date)
      const sDate = dateobj.getDate().toString().padStart(2, '0')
      const sMonth = (dateobj.getMonth() + 1).toString().padStart(2, '0')
      const sYear = dateobj.getFullYear()
      return sYear + '.' + sMonth + '.' + sDate
    }
    return ''
  }

  return (
    <Fragment>
      <section className="requestForm-row">
        {isReady ? (
          <Fragment>
            <HeadingText size="sm" className="text-center requestForm-row">
              <Message id="dsrLoggedout.status.p3" />
            </HeadingText>
            <BodyText className="text-center requestForm-section-desc">
              <Message id="dsrLoggedout.status.p4" />
            </BodyText>
          </Fragment>
        ) : (
          <Fragment>
            <HeadingText size="sm" className="text-center requestForm-row">
              <Message id="dsrLoggedout.status.p1" />
            </HeadingText>
            <BodyText className="text-center requestForm-section-desc">
              <Message id="dsrLoggedout.status.p2" />
            </BodyText>
          </Fragment>
        )}

        <div className="requestForm-section-row status-section">
          <BodyText className="requestForm-section-desc">
            <b>
              <Message id="dsrLoggedout.status.requestid" /> :
            </b>
            <span className="s-value">{dataResponse.id || ''}</span>
          </BodyText>
          <BodyText className="requestForm-section-desc">
            <b>
              <Message id="dsrLoggedout.status.name" /> :
            </b>
            <span className="s-value">
              {dataResponse.customer.name.given_name +
                ' ' +
                dataResponse.customer.name.surname}
            </span>
          </BodyText>
          <BodyText className="requestForm-section-desc">
            <b>
              <Message id="dsrLoggedout.status.email" /> :
            </b>
            <span className="s-value">{dataResponse.email || ''}</span>
          </BodyText>
          <BodyText className="requestForm-section-desc">
            <b>
              <Message id="dsrLoggedout.status.customertype" /> :
            </b>
            <span className="s-value">{dataResponse.customer.type || ''}</span>
          </BodyText>
          <BodyText className="requestForm-section-desc">
            <b>
              <Message id="dsrLoggedout.status.date" /> :
            </b>
            <span className="s-value">
              {formateDate(dataResponse.create_time)}
            </span>
          </BodyText>
        </div>
      </section>

      <Row>
        <Col xs={12}>
          <div className="text-center requestForm-row">
            <Button
              id="continueBtn"
              size="ld"
              onClick={handleContinueClick}
              className="text-center"
            >
              <Message id="dsrLoggedout.status.closebtn" />
            </Button>
          </div>
        </Col>
      </Row>
    </Fragment>
  )
})
Status.displayName = 'Status'
export default asASlide({ position: 1 })(Status)
